import { render, staticRenderFns } from "./draggable-table.vue?vue&type=template&id=59eaae80"
import script from "./draggable-table.vue?vue&type=script&lang=js"
export * from "./draggable-table.vue?vue&type=script&lang=js"
import style0 from "./draggable-table.vue?vue&type=style&index=0&id=59eaae80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports